"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const user_1 = require("../user");
/**
 * Media entity representing different types of media content
 * that can be displayed on digital advertising screens
 */
class MediaEntity {
    mediaType;
    /**
     * @deprecated
     */
    _id;
    id;
    title;
    description;
    duration;
    /**
     * @deprecated
     */
    emit_date;
    /**
     * @deprecated
     */
    price;
    /**
     * @deprecated
     */
    currency;
    /**
     * @deprecated
     */
    fees;
    /**
     * @deprecated
     */
    ratings;
    video;
    audio;
    /**
     * @deprecated
     */
    tweet;
    message;
    image;
    web;
    pdf;
    /**
     * @deprecated
     */
    cams;
    stream;
    /**
     * @deprecated
     */
    direct;
    /**
     * @deprecated
     */
    direct_webcam;
    social;
    qr;
    /**
     * @deprecated
     */
    admefy_tv;
    /**
     * @deprecated
     */
    highlighted;
    is_archive;
    published;
    /**
     * @deprecated
     */
    record;
    /**
     * @deprecated
     */
    vrmefy;
    offlineCapability;
    /**
     * @deprecated
     */
    thumbnail;
    owner;
    /**
     * @deprecated
     */
    allowed_users;
    /**
     * @deprecated
     */
    fork_from;
    /**
     * @deprecated
     */
    comments;
    isMy;
    canRemove;
    updatedAt;
    createdAt;
    metadata;
}
exports.MediaEntity = MediaEntity;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Type of media content",
        example: "video",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "mediaType", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Legacy MongoDB ObjectId (deprecated)",
        deprecated: true,
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the media",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Title of the media content",
        example: "Summer Sale Advertisement",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "title", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Description of the media content",
        example: "Promotional video for summer sale campaign",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "description", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Duration of the media in seconds",
        example: 30,
    }),
    __metadata("design:type", Number)
], MediaEntity.prototype, "duration", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Emission date (deprecated)",
        deprecated: true,
        example: "2024-01-15",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "emit_date", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Price of the media (deprecated)",
        deprecated: true,
        example: 10.99,
    }),
    __metadata("design:type", Number)
], MediaEntity.prototype, "price", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Currency for pricing (deprecated)",
        deprecated: true,
        example: "USD",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "currency", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Fee structure (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            eventOwner: { type: "number", example: 0.15 },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "fees", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Media ratings (deprecated)",
        deprecated: true,
        type: "array",
        items: {
            type: "object",
            properties: {
                owner: { type: "string", example: "user123" },
                score: { type: "number", example: 4.5 },
            },
        },
    }),
    __metadata("design:type", Array)
], MediaEntity.prototype, "ratings", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Video content information",
        type: "object",
        properties: {
            filename: { type: "string", example: "advertisement.mp4" },
            url: { type: "string", example: "https://example.com/videos/advertisement.mp4" },
            width: { type: "number", example: 1920 },
            height: { type: "number", example: 1080 },
            format: { type: "string", example: "mp4" },
            size: { type: "number", example: 25600000 },
            transcoded: { type: "boolean", example: true },
            to_mp4_transcoded: { type: "boolean", example: true },
            metadata: { type: "string", description: "Video metadata as JSON string" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "video", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Audio content information",
        type: "object",
        properties: {
            url: { type: "string", example: "https://example.com/audio/jingle.mp3" },
            format: { type: "string", example: "mp3" },
            size: { type: "number", example: 5120000 },
            metadata: { type: "string", description: "Audio metadata as JSON string" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "audio", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Tweet content (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            text: { type: "string", example: "Check out our latest promotion!" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "tweet", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Text message content",
        type: "object",
        properties: {
            text: { type: "string", example: "Welcome to our store!" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "message", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Image content information",
        type: "object",
        properties: {
            url: { type: "string", example: "https://example.com/images/banner.jpg" },
            width: { type: "number", example: 1920 },
            height: { type: "number", example: 1080 },
            format: { type: "string", example: "jpg" },
            size: { type: "number", example: 512000 },
            metadata: { type: "string", description: "Image metadata as JSON string" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "image", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Web content information",
        type: "object",
        properties: {
            title: { type: "string", example: "Company Website" },
            url: { type: "string", example: "https://example.com" },
            metadata: {
                type: "object",
                properties: {
                    audio: { type: "string", example: "https://example.com/audio.mp3" },
                    video: { type: "string", example: "https://example.com/video.mp4" },
                    author: { type: "string", example: "John Doe" },
                    title: { type: "string", example: "Amazing Product" },
                    description: { type: "string", example: "Best product ever" },
                    image: { type: "string", example: "https://example.com/image.jpg" },
                    provider: { type: "string", example: "Example Corp" },
                    published: { type: "string", example: "2024-01-15" },
                },
            },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "web", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "PDF document information",
        type: "object",
        properties: {
            title: { type: "string", example: "Product Catalog" },
            url: { type: "string", example: "https://example.com/catalog.pdf" },
            image_url: { type: "string", example: "https://example.com/catalog-thumb.jpg" },
            date: { type: "string", example: "2024-01-15" },
            size: { type: "number", example: 2048000 },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "pdf", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Camera configurations (deprecated)",
        deprecated: true,
        type: "array",
        items: {
            type: "object",
            properties: {
                rtsp_id: { type: "string", example: "rtsp_123" },
                always_live: { type: "boolean", example: true },
                record: { type: "boolean", example: false },
                title: { type: "string", example: "Security Camera 1" },
                url: { type: "string", example: "rtsp://example.com/stream" },
            },
        },
    }),
    __metadata("design:type", Array)
], MediaEntity.prototype, "cams", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Live stream information",
        type: "object",
        properties: {
            title: { type: "string", example: "Live Event Stream" },
            url: { type: "string", example: "https://stream.example.com/live" },
            provider: { type: "string", example: "YouTube" },
            providerMediaId: { type: "string", example: "abc123xyz" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "stream", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Direct streaming configuration (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            dvr: { type: "string", example: "enabled" },
            channel_name: { type: "string", example: "live_channel_1" },
            rtmp_url: { type: "string", example: "rtmp://example.com/live" },
            rtmp_key: { type: "string", example: "secret_key_123" },
            sources: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        url: { type: "string", example: "https://example.com/stream" },
                        label: { type: "string", example: "1080p" },
                    },
                },
            },
            online: { type: "boolean", example: true },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "direct", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Direct webcam configuration (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            channel_name: { type: "string", example: "webcam_channel_1" },
            webrtc_url: { type: "string", example: "wss://example.com/webrtc" },
            ready: { type: "boolean", example: true },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "direct_webcam", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Social media content information",
        type: "object",
        properties: {
            title: { type: "string", example: "Social Media Post" },
            url: { type: "string", example: "https://twitter.com/example/status/123" },
            date: { type: "string", example: "2024-01-15" },
            provider: { type: "string", example: "Twitter" },
            providerMediaId: { type: "string", example: "tweet_123456" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "social", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "QR code content for easy access",
        example: "https://qr.code/media123",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "qr", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Admefy TV integration flag (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "admefy_tv", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether the media is highlighted (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "highlighted", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the media is archived",
        example: false,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "is_archive", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the media is published",
        example: true,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "published", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Recording flag (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "record", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "VR integration flag (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "vrmefy", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the media can be used offline",
        example: true,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "offlineCapability", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Thumbnail information (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            url: { type: "string", example: "https://example.com/thumb.jpg" },
            width: { type: "number", example: 300 },
            height: { type: "number", example: 200 },
            format: { type: "string", example: "jpg" },
            size: { type: "number", example: 25600 },
            metadata: { type: "string", description: "Thumbnail metadata as JSON string" },
        },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "thumbnail", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Media owner information",
        type: user_1.UserEntity,
    }),
    __metadata("design:type", user_1.UserEntity)
], MediaEntity.prototype, "owner", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of allowed user IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["user1", "user2"],
    }),
    __metadata("design:type", Array)
], MediaEntity.prototype, "allowed_users", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "ID of the original media this was forked from (deprecated)",
        deprecated: true,
        example: "media_original_123",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "fork_from", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Comment IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["comment1", "comment2"],
    }),
    __metadata("design:type", Array)
], MediaEntity.prototype, "comments", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this media belongs to the current user",
        example: true,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "isMy", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the current user can remove this media",
        example: true,
    }),
    __metadata("design:type", Boolean)
], MediaEntity.prototype, "canRemove", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last update timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "updatedAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Creation timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], MediaEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Metadata associated with the media",
        type: Object,
        example: { key1: "value1", key2: "value2" },
    }),
    __metadata("design:type", Object)
], MediaEntity.prototype, "metadata", void 0);
